import { Quote, Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const REVIEWS = [
    "Già dai primi incontri mi sono sentita ascoltata e compresa, mai giudicata.",
    "Mi ha aiutata a capire meglio me stessa e a vedere le cose da un punto di vista diverso.",
    "Professionista esperto, empatico, fonde la buona pratica con una conoscenza ampia dell'animo umano.",
    "Persona molto Professionale e Umana!",
    "Professionista, preparato molto gentile, con una grande umanità e disponibile ad aiutare le persone.",
];

export const Recensioni = () => (
    <section id="recensioni" className="bg-cream" data-testid="recensioni-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 md:py-32">
            <Reveal className="max-w-2xl">
                <Eyebrow>Recensioni</Eyebrow>
                <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl leading-snug text-ink" data-testid="recensioni-title">
                    Le parole di chi ha intrapreso un percorso
                </h2>
                <p className="mt-6 text-base sm:text-lg text-[#526063] leading-relaxed">
                    Testimonianze reali lasciate dalle persone che hanno scelto di prendersi cura di sé.
                </p>
            </Reveal>

            <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {REVIEWS.map((r, i) => (
                    <Reveal key={i} delay={(i % 3) * 0.1} className={i === 0 ? "md:col-span-2 lg:col-span-1" : ""}>
                        <figure
                            className="h-full rounded-3xl bg-white p-8 sm:p-10 border border-ink/5 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 flex flex-col"
                            data-testid={`testimonial-card-${i}`}
                        >
                            <div className="flex items-center justify-between">
                                <Quote size={28} className="text-terracotta" strokeWidth={1.4} />
                                <div className="flex gap-0.5 text-terracotta" aria-label="Valutazione 5 su 5">
                                    {[...Array(5)].map((_, s) => (
                                        <Star key={s} size={14} fill="currentColor" strokeWidth={0} />
                                    ))}
                                </div>
                            </div>
                            <blockquote className="mt-6 flex-1 font-serif text-lg sm:text-xl text-ink leading-relaxed">
                                "{r}"
                            </blockquote>
                            <figcaption className="mt-7 pt-5 border-t border-ink/5">
                                <span className="text-sm font-semibold text-ink">Recensione da Google</span>
                                <span className="block text-xs text-[#7A8C8E] mt-0.5">Nome omesso per privacy</span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}

                <Reveal delay={0.2}>
                    <div className="h-full rounded-3xl bg-sage-light p-8 sm:p-10 flex flex-col justify-center items-start border border-sage/20">
                        <p className="font-serif text-2xl text-sage-dark leading-snug">
                            Ogni percorso è una storia a sé.
                        </p>
                        <p className="mt-3 text-sm text-sage-dark/70 leading-relaxed">
                            Le recensioni complete sono disponibili sulla pagina Google del professionista.
                        </p>
                        <a
                            href="https://www.google.com/maps/place/Psicologo+dott.+Giovanni+De+Lorenzo/@41.0062865,15.6249566,17z/data=!4m18!1m9!3m8!1s0x1339af00e6bd15f9:0xa83c5ae43b052758!2sPsicologo+dott.+Giovanni+De+Lorenzo!8m2!3d41.0062865!4d15.6275315!9m1!1b1!16s%2Fg%2F11rn7p5fmt!3m7!1s0x1339af00e6bd15f9:0xa83c5ae43b052758!8m2!3d41.0062865!4d15.6275315!9m1!1b1!16s%2Fg%2F11rn7p5fmt?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="reviews-read-all-btn"
                            className="mt-6 inline-flex items-center rounded-full border border-sage-dark/30 text-sage-dark px-6 py-3 text-sm font-semibold hover:bg-sage-dark hover:text-cream transition-all duration-300"
                        >
                            Leggi tutte le recensioni
                        </a>
                        <a
                            href="https://www.miodottore.it/profilo/giovanni-de-lorenzo"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="reviews-miodottore-link"
                            className="mt-3 inline-flex items-center text-sm font-semibold text-sage-dark underline underline-offset-4 hover:text-ink transition-colors duration-300"
                        >
                            Leggi le recensioni su MioDottore
                        </a>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
